import { AxiosResponse } from "axios";
import businessPortalClient from "../businessPortalClient";
import { ProductsSalesAvailability } from "../models/visitor-booking/ProductsSalesAvailability";
import { prebookingProductsApi } from "../api/prebookingProducts.api";

export type PrebookingProductsService = {
  getProductSalesAvailability: (
    physicalZoneUid: string,
    startDate: string,
    endDate: string,
    customerId: string,
    productId: string
  ) => Promise<AxiosResponse<ProductsSalesAvailability>>;
};

export const prebookingProductsService: PrebookingProductsService = (() => {
  const getProductSalesAvailability = (
    physicalZoneUid: string,
    startDate: string,
    endDate: string,
    customerId: string,
    productId: string
  ) =>
    businessPortalClient.get<ProductsSalesAvailability>(
      prebookingProductsApi.getProductSalesAvailabilityUrl(
        physicalZoneUid,
        startDate,
        endDate,
        customerId,
        productId
      )
    );

  return {
    getProductSalesAvailability,
  };
})();
